(function () {
  'use strict';

  angular.module('ringbaPortal').component('payoutSettingsSummary', {
    bindings: {
      payoutSettings: '<',
      disableActions: '<',
      availableTags: '<',
      uploadedBulkTags: '<',
      notUsedPayout: '<',
      isPubOverridden: '<',
      readOnly: '<',
      removePayoutSetting: '&',
      showPayoutSettingsForm: '&',
      hidePayoutSettingsForm: '&'
    },
    controller: PayoutSettingsSummaryController,
    controllerAs: 'vm',
    templateUrl: function($element, $attrs) {
      'ngInject';
      if($attrs.concise) {
        return '/scripts/shared/components/add-affiliate/payout-settings-summary/payout-settings-summary-concise.view.html';
      }
      return '/scripts/shared/components/add-affiliate/payout-settings-summary/payout-settings-summary.view.html';
    }
  });

  function PayoutSettingsSummaryController(
    $filter
  ) {
    'ngInject';

    const vm = this;

    vm.$onChanges = onChanges;

    function onChanges(changesObj) {
      if (changesObj.payoutSettings) {
        _setPayoutInfo();
      }
    }

    function _setPayoutInfo() {
      vm.payoutSummaryText = _getPayoutSummaryText(vm.payoutSettings);
    }

    // TODO: i18n the text
    function _getPayoutSummaryText(payoutSettings) {
      let summaryText;
      if (payoutSettings.isRevShare) {
        if (vm.readOnly) {
          summaryText = 'Revshare Percentage';
        } else {
          const percentage = payoutSettings.revSharePercentage ? payoutSettings.revSharePercentage : '';
          summaryText = percentage + '% of Revenue';

          if (payoutSettings.revShareMaxPayoutAmount > 0 || payoutSettings.revShareMinPayoutAmount > 0)
          {
            summaryText = summaryText + ' (';

            if (payoutSettings.revShareMaxPayoutAmount > 0)
            {
              summaryText = summaryText + 'Max ' + _getCurrencyText(payoutSettings.revShareMaxPayoutAmount);
            }

            if (payoutSettings.revShareMinPayoutAmount > 0)
            {
              if (payoutSettings.revShareMaxPayoutAmount > 0)
              {
                summaryText = summaryText + '/';
              }
              summaryText = summaryText + 'Min ' + _getCurrencyText(payoutSettings.revShareMinPayoutAmount);
            }
            summaryText = summaryText + ')';
          }
        }
      } else {
        summaryText = _getCurrencyText(payoutSettings.payoutAmount);
        if (payoutSettings.payoutConversionType === 'callLength') {
          summaryText += ' if Call Length exceeds ' + _getCallLengthText(payoutSettings.payoutConversionArgs && payoutSettings.payoutConversionArgs.callLengthInSeconds);
        } else {
          summaryText += ' on ' + $filter('camelCaseFormat')(payoutSettings.payoutConversionType);
        }
      }
      return summaryText;
    }

    function _getCallLengthText(callLength) {
      return callLength ? $filter('secondsToTextFormat')(callLength) : '';
    }

    function _getCurrencyText(amount) {
      return typeof amount !== 'undefined' ? $filter('currencyAmountFilter')({ currencyType: {
        code: 'USD'
      }, amount: amount }) : '';
    }

  }
})();
